import { render } from "./KhoDashboard.vue?vue&type=template&id=5572286a&scoped=true"
import script from "./KhoDashboard.vue?vue&type=script&lang=js"
export * from "./KhoDashboard.vue?vue&type=script&lang=js"

import "./KhoDashboard.vue?vue&type=style&index=0&id=5572286a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5572286a"]])

export default __exports__